import { useContext } from 'react';

import { IndividualCalendarContext } from '@pages/IndividualCalendar/context/IndividualCalendarContext';

export const useIndividualCalendarContext = () => {
  const context = useContext(IndividualCalendarContext);

  if (!context) {
    throw new Error(
      'useIndividualCalendarContext must be used within a IndividualCalendarProvider'
    );
  }

  return context;
};
